import { render } from "./ResourceSetting.vue?vue&type=template&id=2635e90a&ts=true"
import script from "./ResourceSetting.vue?vue&type=script&lang=ts"
export * from "./ResourceSetting.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__